import React from "react"
import { Link } from "gatsby"
import uuid from "react-uuid"
import html from "../assets/html.png"
import css from "../assets/css.png"
import javascript from "../assets/javascript.png"
import react from "../assets/react.png"
import gatsby from "../assets/gatsby.png"
import php from "../assets/php.png"
import redux from "../assets/redux.png"
import mysql from "../assets/mysql.png"
import gulp from "../assets/gulp.png"
import webpack from "../assets/webpack.png"
import git from "../assets/git.png"
import seo from "../assets/seo.png"
import facebookads from "../assets/facebookads.png"
import adsense from "../assets/adsense.png"
import marketing from "../assets/marketing.png"

const data = [
  {
    id: uuid(),
    src: html,
    alt: "html logo",
    feature: true,
  },
  {
    id: uuid(),
    src: css,
    alt: "css logo",
    feature: true,
  },
  {
    id: uuid(),
    src: javascript,
    alt: "javascript logo",
    feature: true,
  },
  {
    id: uuid(),
    src: react,
    alt: "reat logo",
    feature: true,
  },
  {
    id: uuid(),
    src: gatsby,
    alt: "gatsby logo",
    feature: true,
  },
  {
    id: uuid(),
    src: redux,
    alt: "redux logo",
    feature: true,
  },
  {
    id: uuid(),
    src: php,
    alt: "php logo",
    feature: true,
  },
  {
    id: uuid(),
    src: mysql,
    alt: "mysql logo",
    feature: true,
  },
  {
    id: uuid(),
    src: webpack,
    alt: "webpack logo",
    feature: false,
  },
  {
    id: uuid(),
    src: gulp,
    alt: "gulp logo",
    feature: false,
  },
  {
    id: uuid(),
    src: git,
    alt: "git logo",
    feature: false,
  },
  {
    id: uuid(),
    src: seo,
    alt: "seo logo",
    feature: false,
  },
  {
    id: uuid(),
    src: adsense,
    alt: "adsense logo",
    feature: false,
  },
  {
    id: uuid(),
    src: facebookads,
    alt: "facebookads logo",
    feature: false,
  },
  {
    id: uuid(),
    src: marketing,
    alt: "marketing logo",
    feature: false,
  },
]
const allLinks = data.map(skill => {
  const { id, src, alt } = skill
  return (
    <div key={id}>
      <img src={src} alt={alt} />
    </div>
  )
})

const PagesSkills = () => {
  return <div className=" section-center skills-card">{allLinks}</div>
}

export default PagesSkills
